import React from 'react'
import Menu from './menu'
import { versao } from '../../consts'

export default props => (
    <asaide className='main-sidebar'>
        <section className='sidebar'>
            <Menu />
        </section>
        <small style={{
            color: 'white', marginLeft: '10px', position: 'absolute', bottom: '20px',       
            fontSize: '12px'
        }}>Versão: {versao}</small>
    </asaide>
)


// WEBPACK FOOTER //
// ./src/common/template/sideBar.jsx